import React, { useEffect, useState } from "react";
import Tooltip from "react-bootstrap/Tooltip";
import { OverlayTrigger } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

const DragDropModal = ({ moduleGroups = [], initialDroppedModules = {}, onDataUpdate, resetTrigger, error }) => {
  const path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

  const [modules, setModules] = useState([]);

  function LinkWithTooltip({ id, children, href, tooltip }) {
    return (
      <OverlayTrigger
        overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
        placement="top"
        delayShow={300}
        delayHide={150}
      >
        <a href={href}>{children}</a>
      </OverlayTrigger>
    );
  }

  // Helper to deep clone and apply initial dropped modules
  const initializeModules = () => {
    return moduleGroups.map(group => {
      let droppedTitles = initialDroppedModules?.[group.id] || [];
      if (typeof droppedTitles === "string") {
        try {
          droppedTitles = JSON.parse(droppedTitles);
          if (!Array.isArray(droppedTitles)) droppedTitles = [droppedTitles];
        } catch {
          droppedTitles = droppedTitles.split(",").map(t => t.trim());
        }
      }
      const droppedItems = droppedTitles?.map(title => group.source.find(item => item.title === title))?.filter(Boolean);

      const remainingSource = group?.source?.filter(item => !droppedTitles.includes(item.title));

      return {
        ...group,
        source: remainingSource,
        target: droppedItems
      };
    });
  };

  useEffect(() => {
    if (moduleGroups.length) {
      const initialized = initializeModules();
      setModules(initialized);
    }
  }, [resetTrigger, moduleGroups, initialDroppedModules]);

  const handleDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    const sourceDroppable = source.droppableId;
    const destDroppable = destination.droppableId;

    const [sourceType, groupId] = sourceDroppable.split("-");
    const [destType, destGroupId] = destDroppable.split("-");

    if (groupId !== destGroupId) return;

    if (sourceDroppable === destDroppable && source.index === destination.index) return;

    setModules(prevModules => {
      const newModules = prevModules.map(group => {
        if (group.id !== groupId) return group;

        const updatedGroup = { ...group };
        const sourceList = sourceType === "source" ? [...group.source] : [...group.target];
        const destList = destType === "source" ? [...group.source] : [...group.target];

        const [movedItem] = sourceList.splice(source.index, 1);

        const isDuplicate = destList.some((item) => item.title === movedItem.title);
        if (isDuplicate) return group;

        if (group.id === "streamingChannel" && destType === "target") {
          // Only one item allowed in target
          destList.length = 0;
        }

        destList.splice(destination.index, 0, movedItem);

        updatedGroup.source = sourceType === "source" ? sourceList : destList;
        updatedGroup.target = sourceType === "source" ? destList : sourceList;

        return updatedGroup;
      });

      // Send updated target values to parent
      const dataForParent = {};
      newModules.forEach(group => {
        if (group.target.length > 0) {
          dataForParent[group.id] = group.target.map(item => item.title);
        }
      });

      if (typeof onDataUpdate === "function") {
        onDataUpdate(dataForParent);
      }

      return newModules;
    });
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      {modules.map((group, index) => (
        <div className="events-drag" key={group.id}>
          <h6>{group.title}</h6>
          <div className="event-drag-drop" style={{ display: "flex"}}>
            {["source", "target"].map(type => {
              const list = type === "source" ? group.source : group.target;
              return (
                <Droppable key={type} droppableId={`${type}-${group.id}`}>
                  {(provided) => (
                      <>
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className={`drag-box${type === "target" && list.length > 0 ? " target-data" : ""}`}
                        >
                          {/* <strong>{type === "source" ? "Available Modules" : "Selected Modules"}</strong> */}
                          {
                            list.length === 0  ?
                            <div className="placeholder-text">
                              <p className="drag-box-msg">Drag {group?.title.toLowerCase()} options here to <br/>  {type == "source" ? "remove" : "include"} them</p>
                            </div>
                            :
                            list.map((item, index) => (
                              <Draggable key={item.title} draggableId={`${item.title}-${group.id}`} index={index}>
                                {(provided) => (
                                  <div className="drag-box-item"
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={{
                                      ...provided.draggableProps.style,
                                    }}
                                    >
                                    <img src={path_image + "drag-drop.svg"} alt="drag-icon" className="drag-icon"/>
                                    {item.title} &nbsp;
                                    <LinkWithTooltip tooltip={item?.tooltip}>
                                      <img src={path_image + "info_circle_icon.svg"} alt="tooltip-btn" />
                                    </LinkWithTooltip>
                                    <img src={path_image + "checkmark-green.svg"} alt="drag-icon" className="checkmark-icon"/>
                                    
                                  </div>
                                )}
                              </Draggable>
                            ))}
                          {provided.placeholder}
                        </div>
                      </>
                  )}
                </Droppable>
              );
            })}
          </div>
          {index === modules.length - 1 && error?.sectionInclude ? (
            <div className="login-validation-section">
              {error?.sectionInclude}
            </div>
          ) : null}
        </div>
      ))}
    </DragDropContext>
  );
};

export default DragDropModal;
